import type { Specials } from '../types/specials';
import { wrapFetch } from '../libs/fetch';
import { OtherSpecials, SpecialDetail } from '../types/specialShow';

export const fetchSpecials = async () => {
  return await wrapFetch<Specials>('/api/v1/specials');
};

export const fetchSpecial = async (id: number) => {
  return await wrapFetch<SpecialDetail>(`/api/v1/specials/${id}`);
};

export const fetchOtherSpecials = async (id: number) => {
  return await wrapFetch<OtherSpecials>(`/api/v1/specials/${id}/get_other_specials`);
};
